<template>
  <section id="documents-section">
    <h1 class="title">{{$resx('DocumentsText')}}</h1>
    <h2 class="subtitle">{{$resx('DocumentsSubtitleText')}}</h2>
    <div>
      <template v-if="partner.report">
        <h3>{{$resx('PersonalDocumentsText')}}</h3>
        <ul class="flex">
          <li class="doc">
            <h4>{{$resx('PdfReportTitleText')}}</h4>
            <p>{{$resx('PdfReportDescriptionText')}}</p>
            <button class="btn btn-primary" :class="{'is-loading':isDownloading}" :disabled="isDownloading" @click="downloadBilan">
              <span>{{$resx('DownloadText')}}</span>
            </button>
          </li>
        </ul>
        <h3>{{$resx('OtherDocumentsText')}}</h3>
      </template>
      <ul class="flex flex-wrap" style="justify-content:flex-start; gap:2%">
        <!--<li class="doc">
    <h4>{{$resx('PdfFlyerTitleText')}}</h4>
    <p>{{$resx('PdfFlyerDescriptionText')}}</p>
    <a class="btn btn-primary" target="_blank" href="https://dyuzi43ld6cwm.cloudfront.net/luxe/docs/livret.pdf">{{$resx('DownloadText')}}</a>
  </li>-->
        <li class="doc">
          <h4>{{$resx('PdfPricesTitleText')}}</h4>
          <p>{{$resx('PdfPricesDescriptionText')}}</p>
          <a class="btn btn-primary" target="_blank" href="https://dyuzi43ld6cwm.cloudfront.net/luxe/docs/tarifs.pdf">{{$resx('DownloadText')}}</a>
        </li>
        <li class="doc">
          <h4>{{$resx('PdfPacksTitleText')}}</h4>
          <p>{{$resx('PdfPacksDescriptionText')}}</p>
          <a class="btn btn-primary" target="_blank" href="https://dyuzi43ld6cwm.cloudfront.net/luxe/docs/flyer_packs.pdf">{{$resx('DownloadText')}}</a>
        </li>
        <li class="doc" v-if="isTranslated">
          <h4>{{$resx('PdfSalesProcessTitleText')}}</h4>
          <p>{{$resx('PdfSalesProcessDescText')}}</p>
          <a class="btn btn-primary" target="_blank" href="https://dyuzi43ld6cwm.cloudfront.net/luxe/docs/Process-ventes.pdf">{{$resx('DownloadText')}}</a>
        </li>
        <li class="doc" v-if="isTranslated">
          <h4>{{$resx('PdfBookingCancelTitleText')}}</h4>
          <p>{{$resx('PdfBookingCancelDescText')}}</p>
          <a class="btn btn-primary" target="_blank" href="https://dyuzi43ld6cwm.cloudfront.net/luxe/docs/Processus-annulation-reservations.pdf">{{$resx('DownloadText')}}</a>
        </li>
      </ul>
      <!--<a :href="'/api/document/test/'+currentCampingId" target="_blank">test</a>-->
    </div>
  </section>
</template>
<script>
import documentsServices from '../services/documentsServices'

export default {
  data () {
    return {
      isDownloading: false
    }
  },
  computed: {
    // compte partenaire connecté
    partner () {
      return this.$store.state.partner.account
    },
    // camping actuellement sélectionné
    currentCampingId () {
      return this.$store.getters['partner/currentCampingId']
    },

    currentLanguage () {
      return this.$store.state.app.language
    },
    isTranslated () {
      return this.currentLanguage === 'fr'
    }
  },
  methods:
  {
    // télécharger son bilan
    downloadBilan () {
      const self = this
      this.isDownloading = true
      documentsServices.downloadReport(this.currentCampingId)
        .then(response => {
          self.isDownloading = false
        })
        .catch(error => {
          self.isDownloading = false
          self.$store.commit('app/showSnack', { type: 'error', message: error.response.data.message })
        })
    }
  },
  mounted: function () {
    this.$store.commit('app/setPage', 'documents')
  }
}

</script>
<style lang="less">
  @import '../assets/variables.less';

  #documents-section
  {
    a.btn
    {
      text-decoration:none;
    }

    h3
    {
      font-size:1.5em;
      font-weight: fontBlack;
      color: @grey9;
      text-transform:uppercase;
      margin:.5em auto;
      display:inline-block;
    }

    h4
    {
      color:@gold;
      font-size:1.25em;
      margin:.5em auto;
    }

   .doc
      {
        text-align:center;
        min-width:300px;
        width:48%;
        padding:1em;
        margin:1em 0;
        border:2px solid @gold;
        border-radius:10px;
        min-height:15em;
        display:flex;
        flex-flow:column nowrap;
        justify-content:space-between;

        p
        {
          color:@dark;
        }
      }
  }

  @media only screen and (min-width: 64em) {
    #documents-section {
      .doc
      {
        width:32%;
        min-height:13em;
      }
    }
  }

  @media only screen and (min-width: 80em) {
    #documents-section {
      .doc
      {
        width:48%;
      }
    }
  }
  @media only screen and (min-width: 100em) {
    #documents-section {
      .doc
      {
        width:32%;
      }
    }
  }
</style>
